<template>
	<div class="content" style="height:100%; width: 100%; display: flex; justify-content: center; align-items: center;">
		<loading v-if="!loaded"/>

		<div class="md-layout" style="height: 100%; width: 100%;" v-if="loaded">
			<div class="md-layout-item md-medium-size-60 md-small-size-60 md-size-60 md-xsmall-size-100 full-width" style="padding: 0 !important">
				<GmapMap id="map" ref="mapRef" :center="{lat:11.544491, lng:104.416873}" :zoom="9" map-type-id="hybrid"
					:options="{zoomControl: true, mapTypeControl: true, scaleControl: true, streetViewControl: false, rotateControl: false, fullscreenControl: false, disableDefaultUi: false}" style="width: 100%; height: 100%">

					<GmapMarker
						:key="index" v-for="(m, index) in sensorList"
						v-if="m.sensor_type_id == 5"
						:position="{lat: m.lat, lng: m.lng}"
						:clickable="true"
						:label="{text: m.name, className: 'marker-label'}"
						icon="/sensor.png"
						@click="openSensor(m)"
					/>
					<GmapMarker
						:key="index" v-for="(m, index) in sensorList"
						v-if="m.sensor_type_id == 2"
						:position="{lat: m.lat, lng: m.lng}"
						:clickable="true"
						:label="{text: m.name, className: 'marker-label'}"
						icon="/sensor-red.png"
						@click="openSensor(m)"
					/>
				</GmapMap>
			</div>
			<div class="md-layout-item md-medium-size-40 md-small-size-40 md-size-40 md-xsmall-size-100 full-width padding-right-section padding-table" style="background-color:red; ; background-color: #FFF;">
				<md-card style="height: calc(100% - 21px); background-color: #FFF; margin: 20px 0 0px;">
					<md-card-header data-background-color="orange"><b>HydroD Monitoring System</b></md-card-header>
					<md-card-content style="overflow-y: scroll;height: calc(100% - 38px)">
						<md-field>
							<label>Sensor Type</label>
							<md-select placeholder="Sensor Type (All)" v-model="filter.sensor_type" @md-selected="filterSensor()">
								<md-option value="">All</md-option>
								<md-option value="5">Rain Gauge Sensor</md-option>
								<md-option value="2">Water Level Sensor</md-option>
							</md-select>
						</md-field>
						<!-- <md-button class="md-button md-theme-default md-primary" @click="openSensor(sensor)">Water Level</md-button>
						<md-button class="md-button md-theme-default md-primary" @click="openSensor(sensor)">Rain Gauge</md-button> -->
						<md-table v-if="sensorList.length > 0">
							<md-table-row>
								<md-table-head><b>Location</b></md-table-head>
								<md-table-head><b>Value</b></md-table-head>
								<!-- <md-table-head>Action</md-table-head> -->
							</md-table-row>

							<md-table-row v-for="(sensor, index) in sensorList" style="cursor: pointer;" @click="openSensor(sensor)">
								<md-table-cell>
									<b>
										<img src="/sensor-red.png" style="width: 16px; margin-right: 1px" v-if="sensor.sensor_type_id == 2">
										<img src="/sensor.png" style="width: 16px; margin-right: 1px" v-if="sensor.sensor_type_id == 5">
										{{ sensor.name }}</b><br>{{sensor.sensor_type_name}}
								</md-table-cell>
								<md-table-cell><span style="background-color: #1ccabd; padding: 5px 8px; border-radius: 10px; color:#FFF"><b>{{ sensor.value }}
									<span v-if="sensor.sensor_type_id == 2">m.</span>
									<span v-if="sensor.sensor_type_id == 5">mm.</span>
								</b></span></md-table-cell>
							</md-table-row>
						</md-table>
					</md-card-content>
				 </md-card>

			</div>
		</div>

		<div class="popup" v-show="show">
			<div class="popup-content">
				<div class="popup-header">
					<div class="md-layout">
						<div class="md-layout-item md-medium-size-100 md-small-size-100 md-size-100">
							<div style="display: flex; flex-direction: row; width: 100%;">
								<div style="width: 100%">
									<h4><b>{{graph.title}}</b> ({{graph.hash}})<br>{{graph.sensor_type_name}}</h4>
									<p>{{graph.description}}</p>
								</div>
								<div>
									<md-button class="md-just-icon md-simple md-danger" @click="closeDialog()">
										<md-icon>close</md-icon>
									</md-button>
								</div>
							</div>

						</div>
						<div class="md-layout-item md-medium-size-20 md-small-size-35 md-size-10">

						</div>
					</div>
				</div>
				<div class="popup-body" v-show="graphLoaded && !download.visible">
					<div class="md-layout" style="display: flex;justify-content: right;">
						<div class="md-layout-item md-medium-size-30 md-small-size-40 md-size-20 text-right">
							<md-field>
								<md-select placeholder="Date Range" v-model="date_range"
									@md-selected="switchDateRange()">
									<md-option value="1">Last 24 hours</md-option>
									<md-option value="7">Last 7 days</md-option>
									<md-option value="30">Last 1 month</md-option>
								</md-select>
							</md-field>
						</div>
					</div>
					<div class="md-layout">

						<div class="md-layout-item md-medium-size-100 md-small-size-100 md-size-100">
							<div id="data_chart" style="min-height: 300px;"></div>
						</div>
						<div class="md-layout-item md-medium-size-100 md-small-size-100 md-size-100">
							<div style="width: 100%; display: flex; flex-direction: row; justify-content: center;">
								<table>
									<tr>
										<td style="width: 120px;text-align: center;">Min.</td>
										<td style="width: 120px;text-align: center;">Max.</td>
										<td style="width: 120px;text-align: center;">Avg.</td>
									</tr>
									<tr>
										<td style="width: 120px;text-align: center;"><b>{{getGraphStat.min}}</b></td>
										<td style="width: 120px;text-align: center;"><b>{{getGraphStat.max}}</b></td>
										<td style="width: 120px;text-align: center;"><b>{{getGraphStat.avg}}</b></td>
									</tr>
								</table>
							</div>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-100 text-center">
							<md-button class="md-raised md-primary" @click="downloadData()">Download This Data</md-button>
						</div>
					</div>

				</div>
				<div class="popup-body" v-if="download.visible">
					<div class="md-layout">
						<div class="md-layout-item md-medium-size-20 md-small-size-10 md-size-25 md-xsmall-size-10"></div>
						<div class="md-layout-item md-medium-size-60 md-small-size-80 md-size-50 md-xsmall-size-80">
							<div class="md-layout">
								<div class="md-layout-item md-small-size-100 md-size-100">
									{{download.error}}
								</div>
								<div class="md-layout-item md-small-size-100 md-size-100">
									<md-field>
										<label>Full Name</label>
										<md-input v-model="download.name" type="text" required></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-100">
									<md-field>
										<label>Email or Phnone Number</label>
										<md-input v-model="download.contact" type="text" required></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-100">
									<md-field>
										<label>Position</label>
										<md-input v-model="download.position" type="text" required></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-100">
									<md-field>
										<label>Institution</label>
										<md-input v-model="download.institution" type="text" required></md-input>
									</md-field>
								</div>
							</div>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-100 text-center">
							<md-button class="md-raised md-primary" @click="downloadData()">Download This Data</md-button>
						</div>
					</div>
				</div>
				<loading v-show="!graphLoaded"/>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		components: {
		},
		data() {
			return {
				show: false,
				graphLoaded: false,
				loaded: false,
				date_range: 7,
				originalSensorList: [],
				sensorList: [],
				dataList: [],
				filter: {
					sensor_type: ""
				},
				interval: null,
				graph: {
					title: "",
					hash: "",
					sensor_type_name: "",
					description: "",
					sensor: {},
					sensor_data: []
				},
				currentSensor: {},
				download: {
					visible: false,
					error: "",
					name: "",
					contact: "",
					position: '',
					institution: ""
				}
			}
		},
		created() {
			this.getSensor();
			this.interval = setInterval(() => {
				this.getSensor();
			}, 20000)
			this.showKML();
		},
		beforeDestroy() {
			clearInterval(this.interval);
		},
		computed: {
			'getGraphStat' () {
				if(this.graph.sensor_data.length > 0) {
					let min = this.graph.sensor_data[0].sensor_value;
					let max = this.graph.sensor_data[0].sensor_value;
					let avg = 0;
					for(let i =0; i < this.graph.sensor_data.length; i++) {
						if(this.graph.sensor_data[i].sensor_value > max) max = this.graph.sensor_data[i].sensor_value;
						if(this.graph.sensor_data[i].sensor_value < min) min = this.graph.sensor_data[i].sensor_value;
						avg = avg + this.graph.sensor_data[i].sensor_value / this.graph.sensor_data.length;
					}
					return {min: parseFloat(min).toFixed(4), max: parseFloat(max).toFixed(4), avg: parseFloat(avg).toFixed(4)};
				} else {
					return {min: "-", max: "-", avg: "-"};
				}
			}
		},
		methods: {
			filterSensor() {
				this.sensorList = [];
				if(this.filter.sensor_type != "") {
					for(let i = 0; i< this.originalSensorList.length; i++) {
						if(this.originalSensorList[i].sensor_type_id == this.filter.sensor_type) {
							this.sensorList.push(this.originalSensorList[i]);
						}
					}
				} else {
					this.sensorList = this.originalSensorList;
				}
			},
			getSensor(more = false) {
				this.$http.get(this.config.api + "/public/sensor/get_list").then(data => {
					this.loaded = true;
					this.sensorList = data.body.data
					this.originalSensorList = data.body.data
					this.filterSensor();
				});
			},
			openSensor(sensor) {
				this.graph.title = sensor.name;
				this.graph.description = sensor.description;
				this.graph.hash = sensor.hash;
				this.graph.sensor_type_name = sensor.sensor_type_name;
				this.graph.sensor = sensor;
				this.show = true;
				this.currentSensor = sensor;
				this.getData();
			},
			updateChart() {
				// this.getData();
			},
			downloadData() {
				if(this.download.visible) {
					if(String(this.download.name).length > 0 && String(this.download.contact).length > 0 && String(this.download.position).length > 0 && String(this.download.institution).length > 0) {
						this.$http.post(this.config.api + "/public/sensor/download", {
							download: this.download
						}).then(data => {
							this.download = {
								visible: false,
								error: "",
								name: "",
								contact: "",
								position: '',
								institution: ""
							}

							let csv = `N, Value ${this.graph.title}, Date (UTC+0)\n`;

							for(let i =0; i< this.graph.sensor_data.length; i++) {
								csv += `${i}, ${this.graph.sensor_data[i].sensor_value}, ${String((new Date(this.graph.sensor_data[i].created_date * 1000)).toLocaleString('en-GB', { timeZone: 'UTC' })).replace(", ", "-")}\n`;
							}

							var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
							var url = URL.createObjectURL(blob);

							var pom = document.createElement('a');
							pom.href = url;
							pom.setAttribute('download', this.graph.title + ".csv");
							pom.click();
						});
					} else {
						this.download.error = "Please fill in information !";
					}
				} else {
					this.download.visible = true;
				}
			},
			showKML() {
				setTimeout(() => {
					if(this.loaded) {
						this.$refs.mapRef.$mapPromise.then((map) => {
							const tonle = new google.maps.KmlLayer({map,
								url: "https://hydrod.net/data/river.kmz",
							});
							let stations = new google.maps.KmlLayer({map,
								url: "https://hydrod.net/data/boundary.kmz",
							});
						})
					} else {
						this.showKML();
					}
				}, 500)
			},
			switchDateRange() {
				this.graphLoaded = false;
				this.getData();
			},
			getData() {
				let sensor = this.currentSensor;
				let type = sensor.sensor_type_id == 2 ? "Water Level (m.)" : "Rain Gauge (mm.)";

				this.$http.get(this.config.api + "/public/sensor/get/" + sensor.hash + "/" + this.date_range).then(data => {

					if(data.body.status == "success") {
						this.dataList = [["Date", type]];
						this.graph.sensor_data = data.body.data;

						for(let i = 0; i< data.body.data.length;i++) {
							this.dataList.push([new Date(data.body.data[i].created_date * 1000), data.body.data[i].sensor_value]);
						}
						setTimeout(() => {
							this.graphLoaded = true;
							setTimeout(() => {
								this.drawGraph(sensor, this.dataList);
							}, 500)
						}, 500)
					}
				});

			},
			closeDialog() {
				this.show = false;
				this.graphLoaded = false;
				this.graph.sensor_data = [];
				document.getElementById("data_chart").innerHTML = "";
				this.dataList = [];
				this.date_range = 7;
				// this.graph
			},
			drawGraph(sensor, array) {
				var data = google.visualization.arrayToDataTable(array);
				var options = {
					title: sensor.sensor_type_name,
					legend: { position: 'bottom' },
					chartArea: { width: '86%', height: 150},
					pointSize: 1,
					colors: ['#1ccabd', '#1ccabd'],
					hAxis: {
						textStyle: {fontSize: 12},
						textPosition: "out",
						showTextEvery: 1,
						// direction:-1,
						slantedText:true,
						slantedTextAngle:45
					}
				};
				var chart = sensor.sensor_type_id == 2 ? new google.visualization.LineChart(document.getElementById("data_chart")) : new google.visualization.ColumnChart(document.getElementById("data_chart"));
				chart.draw(data, options);
			},
		},
		mounted() {
			google.charts.load('current', { packages: ['corechart', 'bar'] });
			// console.log(this.$refs.mapRef);

			// console.log(GmapMap);
			// let stations = new google.maps.KmlLayer({
			// 	url: "https://traware.com/map/stations.kml",
			// });
			// stations.setMap(map);
			// this.$refs.mapRef.$mapPromise.then((map) => {
			// })
		}
	}
</script>

<style>
	.marker-label {
		color: #FFF !important;
		text-shadow: -1px -1px 0 #1ccabd, 1px -1px 0 #1ccabd, -1px 1px 0 #1ccabd, 1px 1px 0 #1ccabd;
		margin-top: -30px;
	}
	@media only screen and (max-width: 600px) {
		.full-width {
			height: 50%;
		}
		.padding-right-section {
			padding-top: 18px;
		}
		.padding-table {
			padding-left: 0px !important;
			padding-right: 0px !important;
		}
	}

	@media only screen and (min-width: 601px) {
		.full-width {
			height: 100%;
		}
		.padding-table {
			padding-left: 20px !important;
			padding-right: 20px !important;
		}
	}

	.popup {
		width: 100%;
		height: 100%;
		z-index: 3;
		top: 0;
		left: 0;
		position: fixed;
		background-color: rgba(0,0,0,0.5);
	}
	.popup-body {
		/* overflow: scroll; */
	}
	.popup-content {
		background-color: #FFF;
		overflow: scroll;
		border-radius: 5px;
		top: 25px;
		width: calc(100% - 32px);
		left: 16px;
		position: absolute;
		height: calc(100% - 50px);
	}
	@media only screen and (min-width: 1200px) {
		.popup-content {
			width: calc(100% - 500px);
			left: 250px;
			/* height: calc(100% - 200px);
			top: 100px; */
		}
	}
	/* #003144 */
	.md-textarea {
		min-height: 400px !important;
	}

	.md-list-item-text {
		line-height: 48px !important;
		padding: 0px 18px !important;
	}

	.el-tabs__item.is-active {
		color: #003144 !important;
	}

	.el-tabs__item:hover {
		color: #003144 !important;
	}

	.el-tabs__active-bar {
		background-color: #003144 !important;
	}

	.md-progress-bar-fill {
		background-color: #003144 !important;
	}

	.md-progress-bar {
		background-color: #3c7ab736 !important;
	}

	.md-title {
		letter-spacing: 0 !important;
	}

	.vdatetime-input {
		border: 0;
		width: 100%;
		height: 32px;
	}

	.vdatetime {
		width: 100%;
	}
	.md-list-item-text {
		font-family: "Kantumruy", "Nunito";
	}
	.md-list.md-theme-default .md-selected .md-list-item-content, .md-list.md-theme-default .router-link-exact-active .md-list-item-content {
		color: #003144;
	}
	.wrapper {
		height: 100% !important;
	}
	.md-radio.md-theme-default.md-checked.md-primary .md-radio-container:after {
		background-color: #003144 !important;
	}
	.md-radio.md-theme-default.md-checked.md-primary .md-radio-container {
		border-color: #003144 !important;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue